export const getBirdLoaded = (state) =>state.birdLoader.loaded;